// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NavDownLightIconSignature {
  Element: SVGSVGElement;
}

export const NavDownLightIcon: TOC<NavDownLightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M1.9 6.39999L11.9 16.4L22 6.29999L22.7 6.99999L11.9 17.8L1.2 7.09999L1.9 6.39999Z"/>
</svg>
</template>;